<template>
  <div id="replacement-quotes-component" class="replacement-quotes-component generic-component">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="title d-flex flex-row justify-content-between align-items-center">
            <h1><template v-if="quote">Replacement</template><template v-else>Suggested</template> <span>Quote</span></h1>
          </div>
        </div>
      </div>
      <div class="row" v-if="session?.driverProfile && replacementQuotes.length > 0">
        <div class="col-12">
          <div class="card with-shadow with-half-padding quote-selector">
            <ul class="list-inline p-0 m-0">
              <li class="list-inline-item px-3">
                <b>
                  Your
                  <span v-if="quote">
                    replacement
                  </span>
                  <span v-else>
                    suggested
                  </span>
                  quotes
                </b>
              </li>
              <template v-for="replacementQuote in replacementQuotes">
                <li class="list-inline-item">
                  <button
                    class="btn"
                    v-bind:class="{
                      'btn-light': (selectedReplacementQuoteId !== replacementQuote.quoteID),
                      'btn-primary': (selectedReplacementQuoteId === replacementQuote.quoteID),
                    }"
                    @click="selectedReplacementQuoteId = replacementQuote.quoteID"
                  >
                    {{ replacementQuote.quoteID }}
                  </button>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>

      <template v-if="session?.driverProfile && replacementQuotes.length === 0">
        <div class="my-5">
          <p class="text-center" style="font-size:22px;font-style: italic;">
            There are no <template v-if="quote">replacement</template><template v-else>suggested</template> quotes left to view for this scheme.
            Return to <RouterLink :to="{ name: 'Your Dashboard' }">your dashboard</RouterLink></p>
        </div>
      </template>
      <template v-else>
        <template v-if="session.driverProfile">
          <VehicleGrid
            :session="session"
            :quote="quote"
            :replacementQuotes="replacementQuotes"
            :selectedReplacementQuoteId="selectedReplacementQuoteId"
            :adminPortalData="adminPortalData"
          />
        </template>
        <template v-else>
          <div class="text-center my-5">
            <loading-icon/>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {EventBus} from '@/event-bus.js';
import VehicleGrid from "./replacement-quotes/vehicle-grid";
import LoadingIcon from "./loading-icon.vue";
import {useRoute} from "vue-router";

export default {
  name: "replacement-quotes",

  components: {VehicleGrid, LoadingIcon},

  props: [
    'session',
    'adminPortalData',
  ],

  data() {
    return {
      selectedReplacementQuoteId: null
    }
  },

  setup() {
    const route = useRoute();
    return { route }
  },

  beforeMount(to, from, next) {
    EventBus.$emit('fetchData', [
      'orders',
      'driverprofile',
      'drivergrades',
    ]);
  },

  mounted() {
    EventBus.$on('rejected-replacement', (rejectedReplacement) => {
      for (let i = 0; i < this.session.driverProfile.replacementQuotes[this.route.params.scheme].length; i++) {
        if (this.session.driverProfile.replacementQuotes[this.route.params.scheme][i].quoteID === rejectedReplacement) {
          this.session.driverProfile.replacementQuotes[this.route.params.scheme].splice(i, 1);

          if (this.session.driverProfile.replacementQuotes[this.route.params.scheme][0]) {
            this.selectedReplacementQuoteId = this.session.driverProfile.replacementQuotes[this.route.params.scheme][0].quoteID;
            window.scrollTo(0, 0);
          }

          if (this.session.driverProfile.replacementQuotes[this.route.params.scheme].length === 0) {
            EventBus.$emit('no-replacements-left', true);
          }
        }
      }
    });

    if (!this.selectedReplacementQuoteId && this.session?.driverProfile?.replacementQuotes?.[this.route.params.scheme] && this.session?.driverProfile?.replacementQuotes?.[this.route.params.scheme].length) {
      this.selectedReplacementQuoteId = this.session.driverProfile?.replacementQuotes[this.route.params.scheme][0].quoteID;
    }
  },

  watch: {
    session(newSession, oldSession) {
      if (!this.selectedReplacementQuoteId && newSession?.driverProfile?.replacementQuotes?.[this.route.params.scheme]) {
        this.selectedReplacementQuoteId = newSession.driverProfile.replacementQuotes[this.route.params.scheme][0].quoteID;
      }
    },
  },

  computed: {
    quote() {
      return this.session?.driverProfile?.orderRequest;
    },

    replacementQuotes() {
      const replacementQuotesForScheme = this.session?.driverProfile?.replacementQuotes?.[this.route.params.scheme] || [];

      if (replacementQuotesForScheme.length === 0) {
        EventBus.$emit('no-replacements-left', true);
      }

      return replacementQuotesForScheme;
    }
  }
}
</script>

<style scoped>

</style>
